import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../common/types';
import { assetShareMessages } from './assetShareMessages';
import { previewNoteMessages } from '../promote/preview/previewNoteMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the share page; each part uses its own slice of it */
import styles from './AssetShare.module.scss';
/* eslint-enable css-modules/no-unused-class */

/**
 * The "Preview" chip of a Free plan or trial render (design asset-share c6, pricing spec
 * 2026-10-08). The visitor is not the owner: the note is plain text, with no upgrade action. The
 * chip shows the note on hover, and a screen reader reads it.
 */
const AssetSharePreviewChipComponent: React.FC<{ className?: string }> = ({ className }) => {
  const intl = useIntl();
  const note = intl.formatMessage(previewNoteMessages.note);
  return (
    <span className={clsx(styles.previewChip, className)} title={note}>
      <span aria-hidden>{intl.formatMessage(assetShareMessages.preview)}</span>
      <span className="visually-hidden" data-testid="asset-share-preview-note">
        {note}
      </span>
    </span>
  );
};

export const AssetSharePreviewChip = TypedMemo(AssetSharePreviewChipComponent);
